var map = {
	"./1-makhana-banner.jpeg": 37,
	"./2-khakhra-banner.jpeg": 677,
	"./3-makhana-banner.jpeg": 899,
	"./4-khakhra-banner.jpeg": 831,
	"./5-makhana-banner.png": 412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 941;